// extracted by mini-css-extract-plugin
export default {"container":"SuccessOfferDetail_container__AoQ-m","subtitle":"SuccessOfferDetail_subtitle__b0efJ","hintWrapper":"SuccessOfferDetail_hintWrapper__GrgbN"};